import type { Message } from "./types";

export function buildEngineHistory(
  messages: Message[],
  maxHistoryMessages: number | undefined,
  currentUserContent: string,
): Message[] {
  const history = messages.slice(-Math.max(1, maxHistoryMessages ?? 12));
  history[history.length - 1] = { role: "user", content: currentUserContent };
  return history;
}
